import { Head } from 'vite-react-ssg';
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import DeepseekChat from "@/components/DeepseekChat";
import LastUpdated from "@/components/LastUpdated";

const SUGGESTIONS = [
  "Explain DeepSeek V4 Flash in simple terms",
  "Write a Python function for binary search",
  "Compare DeepSeek V4 vs GPT-5",
  "How many r's are in 'strawberry'?",
];

const ChatPage = () => {
  return (
    <>
      <Head>
        <title>Free DeepSeek V3.1 Demo (Unofficial, No Signup) | 2026</title>
        <meta
          name="description"
          content="Unofficial demo of the open-weight DeepSeek V3.1 model, no signup. Not DeepSeek's official chat: for V4-Pro and V4-Flash, use chat.deepseek.com."
        />
        <link rel="canonical" href="https://deepseek.ai/chat" />
        <meta property="og:title" content="Free DeepSeek V3.1 Demo (Unofficial, No Signup)" />
        <meta property="og:description" content="Unofficial demo of open-weight DeepSeek V3.1 via third-party routes. For V4-Pro and V4-Flash, use the official chat.deepseek.com." />
        <meta property="og:image" content="https://deepseek.ai/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Free DeepSeek V3.1 Demo (Unofficial, No Signup)" />
        <meta name="twitter:description" content="Unofficial demo of open-weight DeepSeek V3.1 via third-party routes. For V4-Pro and V4-Flash, use the official chat.deepseek.com." />
        <meta name="twitter:image" content="https://deepseek.ai/og-image.png" />
      </Head>

      <main className="min-h-screen bg-gradient-to-b from-slate-50 to-white pt-24 pb-8 px-4">
        <div className="max-w-4xl mx-auto">
          <header className="text-center mb-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0066FF]/10 text-[#0066FF] text-sm font-medium mb-3">
              <Sparkles className="h-4 w-4" />
              Free demo · DeepSeek V3.1 via community routes
            </div>
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
              Unofficial DeepSeek V3.1 demo
            </h1>
            <p className="mt-2 text-slate-600 max-w-2xl mx-auto">
              Type in the box below to try DeepSeek without an account. This independent demo runs{" "}
              <strong>DeepSeek V3.1</strong> on free community routes (falling back to R1 when a route is busy), so
              answers and speed can vary. It does <strong>not</strong> run V4-Flash or V4-Pro. For the
              current <strong>V4-Pro</strong> and <strong>V4-Flash</strong> models, use the{" "}
              <a href="https://chat.deepseek.com" target="_blank" rel="noopener noreferrer" className="text-[#0066FF] underline">
                official DeepSeek chat
              </a>{" "}
              (see our <Link to="/login" className="text-[#0066FF] underline">login guide</Link>).
            </p>
            <div className="mt-4 flex justify-center">
              <LastUpdated date="2026-09-09" />
            </div>
          </header>

          <div role="note" className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            <strong>Not the official DeepSeek chat.</strong> This is an independent demo running the open-weight
            DeepSeek V3.1 model through third-party providers. It is not operated by, affiliated with or endorsed by
            DeepSeek. Never enter your DeepSeek password here. The official app is at{" "}
            <a href="https://chat.deepseek.com" target="_blank" rel="noopener noreferrer" className="underline font-medium">
              chat.deepseek.com
            </a>.
          </div>

          <DeepseekChat
            variant="full"
            suggestions={SUGGESTIONS}
            placeholder="Ask the demo anything…"
          />
        </div>
      </main>
    </>
  );
};

export default ChatPage;
